"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../../../elements/other/actions/index"));
var _renderRating = require("../../../../../page-body/sections/smart-testimonials-section/render-rating");
var _settings = require("@site/pattern-library-core/settings");
var _text = _interopRequireDefault(require("@ux/text"));
const Bar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Bar",
  class: "pl-b1er35v3"
});
const Rating = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Rating",
  class: "pl-r1bqvgba"
});
const CtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaContainer",
  class: "pl-c1pdxdwp"
});
const LogoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LogoContainer",
  class: "pl-l6c096w"
});

/**
 * TrustpilotBar Component.
 *
 * @param {Object} props React props
 * @param {Number} props.rating Review Ratings
 * @param {String} props.ratingText Rating Description
 * @param {Object} props.cta ScrollAnchor Target Id
 * @param {String} props.trustpilotUrl Trustpilot URL
 * @param {Object} props.trustpilotLogo Trustpilot logo image URL and alt text
 * @returns {React.ReactElement} TrustpilotBar Component
 * @public
 */

function TrustpilotBar({
  rating,
  ratingText,
  cta,
  trustpilotUrl,
  trustpilotLogo
}) {
  const content = ratingText?.replace(/[\\[\]]/g, '');
  return /*#__PURE__*/_react.default.createElement(Bar, {
    "data-cy": "trustpilot-bar",
    className: "trustpilot-bar"
  }, rating && /*#__PURE__*/_react.default.createElement("a", {
    href: trustpilotUrl,
    rel: "noreferrer",
    "aria-label": "trustpilot",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(Rating, {
    "data-cy": "rating"
  }, (0, _renderRating.renderRating)(rating, 19))), /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "paragraph",
    size: 0,
    "data-cy": "rating-text"
  }, content), trustpilotLogo && /*#__PURE__*/_react.default.createElement(LogoContainer, null, /*#__PURE__*/_react.default.createElement("a", {
    href: trustpilotUrl,
    rel: "noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_image.LazyImage, trustpilotLogo))), cta && /*#__PURE__*/_react.default.createElement(CtaContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      design: 'inline',
      size: 'small'
    }]
  })));
}
var _default = exports.default = TrustpilotBar;
TrustpilotBar.propTypes = {
  rating: _propTypes.default.oneOf(_settings.TrustPilotRatings),
  ratingText: _propTypes.default.string,
  cta: _propTypes.default.object,
  trustpilotUrl: _propTypes.default.string,
  trustpilotLogo: _propTypes.default.shape(_image.imgPropShape)
};